import { z } from 'zod';

export const giftRequestFormSchema = (
  isEdit: boolean,
  hasRejectReason: boolean
) =>
  z.object({
    giftId: z.string().min(1, 'Vui lòng chọn quà'),
    customerIds: z.array(z.string()).min(1, 'Vui lòng chọn khách hàng'),
    assignedToId: z.string().min(1, 'Vui lòng chọn người phụ trách'),
    numberOfGiftsPerCustomer: z
      .number({
        invalid_type_error: 'Vui lòng nhập số lượng quà/khách hàng',
        required_error: 'Vui lòng nhập số lượng quà/khách hàng',
      })
      .min(1, 'Vui lòng nhập số lượng quà phải lớn hơn 0'),
    reason: z
      .string()
      .min(1, 'Vui lòng nhập lý do')
      .refine(
        (val) => val.trim().length > 0,
        'Lý do không được chỉ chứa khoảng trắng'
      ),
    explanation:
      isEdit && hasRejectReason
        ? z
            .string({
              invalid_type_error: 'Vui lòng nhập lý do muốn được phê duyệt lại',
              required_error: 'Vui lòng nhập lý do muốn được phê duyệt lại',
            })
            .min(1, 'Vui lòng nhập lý do muốn được phê duyệt lại')
            .refine(
              (val) => val.trim().length > 0,
              'Lý do không được chỉ chứa khoảng trắng'
            )
        : z
            .string()
            .refine(
              (val) => !val || val.trim().length > 0,
              'Lý do không được chỉ chứa khoảng trắng'
            )
            .optional(),
  });

export type GiftRequestFormValues = z.infer<
  ReturnType<typeof giftRequestFormSchema>
>;
